import Skeleton from "react-loading-skeleton";

import { DashboardCard2 } from "@/components/layout/DashboardCard2";

import "react-loading-skeleton/dist/skeleton.css";

export function RequireCosignatureSkeleton() {
  return (
    <DashboardCard2 className="tw:mb-6" title={<Skeleton width={140} />}>
      <div className="tw:flex tw:items-start tw:gap-5.5">
        <Skeleton borderRadius={12} height={24} width={44} />
        <div className="tw:flex tw:flex-col tw:gap-2">
          <Skeleton height={16} width={120} />
          <Skeleton height={12} width={320} />
        </div>
      </div>
    </DashboardCard2>
  );
}
